import { useTexts } from '../../../../contexts/TextsContext';
import { useData } from '../../../../contexts/DataContext';
import ProjectLogo from './projectLogo/ProjectLogo';
import classes from './projects.module.scss';

const Projects = () => {
    const texts = useTexts();
    const { projects } = useData();

    return (
        <section className={classes.Projects} aria-label={texts.projectsHeading}>
            <ul className={classes.Inner}>
                {projects.map((project) => (
                    <ProjectLogo key={project.id} project={project} />
                ))}
            </ul>
        </section>
    );
};

export default Projects;
